// JAPAN WEB CLINIC (Dawn) — the hotel search on the receiving form (purchase UX plan 段2 F-67; owner 2026-10-17).
// Typing the hotel's name lists hotels in Japan (Google Places API (New) Autocomplete, lodging only), in the page's
// language (owner 2026-10-20: Japanese, Chinese and Korean too; the typed name matches in any language). The name saved
// is English on the English pages and the hotel's Japanese name on the others: okurun prints it on Sagawa's waybill,
// which takes English letters or Japanese only (no Hangul or Chinese characters; okurun plan §4 お届け先名称１).
// choosing one fills the hotel name, the prefecture and the hotel's phone, and keeps its address in Japanese (postal
// code, city, street) for checkout's address (F-66: assets/jwc-core.js checkoutAddress, via J.hotelFound). When the
// key is empty (Theme settings → JWC 受け取り・日程) or Google does not answer, the field stays a plain text field.
// The list favours hotels around the chosen prefecture (the field just above), or all of Japan before one is chosen:
// without that, Google guesses from the visitor's internet address (owner 2026-10-20: chain names and 「東京」 listed
// Osaka's hotels only).
// One session token from the first letter to the choice keeps the cost at one Place Details call (Google's pricing).
// The found address is kept in this browser (localStorage), so the cart in another tab or later can still use it;
// checkout only takes it while the order's hotel name and prefecture are the same (assets/jwc-core.js).
// The list shows 「Google Maps」, as Google asks when its data is shown without its map.
(function () {
  const J = (window.JWC = window.JWC || {});
  const KEY = (J.settings || {}).places || '';
  const LANG = { ja: 'ja', 'zh-CN': 'zh-CN', 'zh-TW': 'zh-TW', ko: 'ko' }[(J.settings || {}).locale] || 'en';
  const FOUND = 'jwc-hotel-found';
  let found = null;
  try {
    found = JSON.parse(localStorage.getItem(FOUND) || 'null');
  } catch (e) {
    found = null;
  }
  // what the search found for this very hotel name (checkout only uses an address that belongs to the name kept)
  J.hotelFound = (name) => (found && found.hotel === String(name || '').trim() ? found : null);
  if (!KEY) return;

  const uuid = () => (crypto.randomUUID ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  }));
  // Google's Japanese addresses use full-width digits and minus signs: half-width for checkout and the waybill
  const half = (s) => String(s || '').replace(/[０-９]/g, (d) => String.fromCharCode(d.charCodeAt(0) - 0xfee0)).replace(/[−－‐]/g, '-').trim();

  // each prefecture's capital (the prefectural office, rounded): Google's circle reaches 50 km at most and only ranks
  // what is near first, so hotels farther away in the same prefecture are still listed
  const CENTER = {
    北海道: [43.064, 141.347], 青森県: [40.824, 140.74], 岩手県: [39.704, 141.153], 宮城県: [38.269, 140.872],
    秋田県: [39.719, 140.102], 山形県: [38.24, 140.363], 福島県: [37.75, 140.468], 茨城県: [36.342, 140.447],
    栃木県: [36.566, 139.884], 群馬県: [36.391, 139.061], 埼玉県: [35.857, 139.649], 千葉県: [35.605, 140.123],
    東京都: [35.681, 139.767], 神奈川県: [35.448, 139.643], 新潟県: [37.903, 139.024], 富山県: [36.695, 137.211],
    石川県: [36.595, 136.626], 福井県: [36.065, 136.222], 山梨県: [35.664, 138.568], 長野県: [36.651, 138.181],
    岐阜県: [35.391, 136.722], 静岡県: [34.977, 138.383], 愛知県: [35.18, 136.907], 三重県: [34.73, 136.509],
    滋賀県: [35.005, 135.869], 京都府: [35.021, 135.756], 大阪府: [34.686, 135.52], 兵庫県: [34.691, 135.183],
    奈良県: [34.685, 135.833], 和歌山県: [34.226, 135.168], 鳥取県: [35.504, 134.238], 島根県: [35.472, 133.051],
    岡山県: [34.662, 133.934], 広島県: [34.397, 132.46], 山口県: [34.186, 131.471], 徳島県: [34.066, 134.559],
    香川県: [34.34, 134.043], 愛媛県: [33.842, 132.766], 高知県: [33.56, 133.531], 福岡県: [33.606, 130.418],
    佐賀県: [33.249, 130.299], 長崎県: [32.745, 129.874], 熊本県: [32.79, 130.742], 大分県: [33.238, 131.613],
    宮崎県: [31.911, 131.424], 鹿児島県: [31.56, 130.558], 沖縄県: [26.212, 127.681],
  };
  const JAPAN = { rectangle: { low: { latitude: 24, longitude: 122.9 }, high: { latitude: 45.6, longitude: 154 } } };
  const near = (pref) => {
    const c = CENTER[pref];
    return c ? { circle: { center: { latitude: c[0], longitude: c[1] }, radius: 50000 } } : JAPAN;
  };

  async function suggest(input, token, signal, pref) {
    const res = await fetch('https://places.googleapis.com/v1/places:autocomplete', {
      method: 'POST',
      signal,
      headers: { 'Content-Type': 'application/json', 'X-Goog-Api-Key': KEY },
      body: JSON.stringify({ input, languageCode: LANG, regionCode: 'JP', includedRegionCodes: ['jp'], includedPrimaryTypes: ['lodging'], locationBias: near(pref), sessionToken: token }),
    });
    if (!res.ok) throw new Error(`autocomplete ${res.status}`);
    const data = await res.json();
    return (data.suggestions || []).map((s) => s.placePrediction).filter(Boolean).map((p) => ({
      id: p.placeId,
      name: p.structuredFormat?.mainText?.text || p.text?.text || '',
      where: p.structuredFormat?.secondaryText?.text || '',
    }));
  }

  // the address in Japanese: 〒 postal code, prefecture, city (郡＋町村, or 市＋区 for the big cities), street
  async function details(id, token) {
    const res = await fetch(`https://places.googleapis.com/v1/places/${encodeURIComponent(id)}?languageCode=ja&regionCode=JP&sessionToken=${encodeURIComponent(token)}`, {
      headers: { 'X-Goog-Api-Key': KEY, 'X-Goog-FieldMask': 'displayName,addressComponents,formattedAddress,postalAddress,nationalPhoneNumber' },
    });
    if (!res.ok) throw new Error(`details ${res.status}`);
    const d = await res.json();
    const comp = (type) => (d.addressComponents || []).find((c) => (c.types || []).includes(type))?.longText || '';
    const pref = d.postalAddress?.administrativeArea || comp('administrative_area_level_1');
    const locality = comp('locality');
    const ward = comp('sublocality_level_1');
    const city = comp('administrative_area_level_2') + locality + (/市$/.test(locality) && /区$/.test(ward) ? ward : '');
    let street = String(d.formattedAddress || '').replace(/^〒?\s*\d{3}-?\d{4}\s*/, '');
    if (pref && street.startsWith(pref)) street = street.slice(pref.length);
    if (city && street.startsWith(city)) street = street.slice(city.length);
    else street = (d.postalAddress?.addressLines || []).join(' ').replace(city, '');
    return { pref, zip: half(d.postalAddress?.postalCode || comp('postal_code')), city, address1: half(street), phone: half(d.nationalPhoneNumber || ''), nameJa: String(d.displayName?.text || '').trim() };
  }

  function attach(form) {
    const input = form.elements.namedItem('hotel');
    if (!input || input.dataset.jwcHotelSearch) return;
    input.dataset.jwcHotelSearch = '1';
    const wrap = input.closest('[data-field]') || input.parentElement;
    const list = document.createElement('div');
    list.className = 'jwc-hotel-search';
    list.id = `${form.id || 'JwcReceive'}-hotel-list`;
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    wrap.classList.add('jwc-hotel-search-wrap');
    wrap.append(list);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', list.id);

    let token = '';
    let items = [];
    let active = -1;
    let timer = 0;
    let controller = null;
    let lastQuery = '';
    let filledPhone = '';
    // the latest choice: a hotel's address that comes back after another hotel was chosen, or after the name was typed
    // over, is dropped (JWC-04: hotel B's name with hotel A's address, or the field going back to A)
    let picked = 0;
    const field = (name) => form.elements.namedItem(name);
    const fire = (el, type) => el && el.dispatchEvent(new Event(type, { bubbles: true }));

    function close() {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }
    function mark(i) {
      active = i;
      [...list.querySelectorAll('[role="option"]')].forEach((el, k) => el.setAttribute('aria-selected', k === i ? 'true' : 'false'));
      if (i >= 0) input.setAttribute('aria-activedescendant', `${list.id}-${i}`);
      else input.removeAttribute('aria-activedescendant');
    }
    function show() {
      list.replaceChildren();
      items.forEach((it, i) => {
        const opt = document.createElement('div');
        opt.className = 'jwc-hotel-search__option';
        opt.id = `${list.id}-${i}`;
        opt.setAttribute('role', 'option');
        opt.setAttribute('aria-selected', 'false');
        const name = document.createElement('span');
        name.className = 'jwc-hotel-search__name';
        name.textContent = it.name;
        const where = document.createElement('span');
        where.className = 'jwc-hotel-search__where';
        where.textContent = it.where;
        opt.append(name, where);
        opt.addEventListener('mousedown', (e) => e.preventDefault());
        opt.addEventListener('click', () => choose(i));
        list.append(opt);
      });
      const credit = document.createElement('div');
      credit.className = 'jwc-hotel-search__credit';
      credit.setAttribute('aria-hidden', 'true');
      credit.textContent = 'Google Maps';
      list.append(credit);
      list.hidden = !items.length;
      input.setAttribute('aria-expanded', items.length ? 'true' : 'false');
      mark(-1);
    }
    async function run() {
      const q = input.value.trim();
      if (q.length < 2 || q === lastQuery) {
        if (q.length < 2) close();
        return;
      }
      lastQuery = q;
      if (!token) token = uuid();
      controller?.abort();
      controller = new AbortController();
      try {
        items = (await suggest(q, token, controller.signal, field('pref')?.value)).slice(0, 5);
        if (input.value.trim() === q && document.activeElement === input) show();
      } catch (e) {
        if (e.name !== 'AbortError') close();
      }
    }
    async function choose(i) {
      const it = items[i];
      if (!it) return;
      const mine = ++picked;
      close();
      input.value = it.name;
      lastQuery = it.name;
      fire(input, 'input');
      try {
        const a = await details(it.id, token);
        if (mine !== picked || input.value !== it.name) return;
        token = '';
        // not on the English pages: the hotel's Japanese name (printable on the waybill), shown in the field as saved
        if (LANG !== 'en' && a.nameJa && a.nameJa !== input.value) {
          input.value = a.nameJa;
          lastQuery = a.nameJa;
          fire(input, 'input');
        }
        const pref = field('pref');
        if (pref && a.pref && [...pref.options].some((o) => o.value === a.pref) && pref.value !== a.pref) {
          pref.value = a.pref;
          fire(pref, 'change');
        }
        const phone = field('phone');
        // the hotel's phone, unless the guest typed one (the booking's number wins: okurun §4)
        if (phone && a.phone && (!phone.value.trim() || phone.value === filledPhone)) {
          phone.value = a.phone;
          filledPhone = a.phone;
          fire(phone, 'input');
        }
        found = { hotel: input.value.trim(), pref: a.pref, zip: a.zip, city: a.city, address1: a.address1 };
        try {
          localStorage.setItem(FOUND, JSON.stringify(found));
        } catch (e) {
          /* checkout simply asks for the address */
        }
        fire(input, 'change');
      } catch (e) {
        token = '';
      }
    }
    const later = () => {
      clearTimeout(timer);
      timer = setTimeout(run, 250);
    };
    input.addEventListener('input', (e) => {
      if (e.isTrusted) picked++; // typed by the guest (not our own event): a choice still waiting is no longer theirs
      later();
    });
    // Chinese and Korean keyboards: also when a word is confirmed (some phones send no input event after it)
    input.addEventListener('compositionend', later);
    input.addEventListener('keydown', (e) => {
      if (list.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        const n = items.length;
        mark(e.key === 'ArrowDown' ? (active + 1) % n : (active - 1 + n) % n);
      } else if (e.key === 'Enter' && active >= 0) {
        e.preventDefault();
        choose(active);
      } else if (e.key === 'Escape') {
        close();
      }
    });
    input.addEventListener('blur', () => setTimeout(close, 150));
  }

  function start() {
    document.querySelectorAll('form[data-jwc-receive-form], form#JwcReceiveForm, form#JwcReceiveCartForm').forEach(attach);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
